import { render, staticRenderFns } from "./ELMessage.vue?vue&type=template&id=1d89facd&scoped=true"
import script from "./ELMessage.vue?vue&type=script&lang=js"
export * from "./ELMessage.vue?vue&type=script&lang=js"
import style0 from "./ELMessage.vue?vue&type=style&index=0&id=1d89facd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89facd",
  null
  
)

export default component.exports